import { Component, Input } from '@angular/core'
import { Footnote } from 'src/app/models/footnote.model'
import { Returns } from 'src/app/models/performance-response.model'

@Component({
  selector: 'performance-cumulative',
  templateUrl: './performance-cumulative.component.html',
  styleUrls: ['./performance-cumulative.component.scss'],
})
export class PerformanceCumulativeComponent {
  @Input() data: Returns
  @Input() profileData: any
  @Input() benchmarkFootNote: Footnote
  @Input() performanceFootNote: Footnote
  @Input() marketPriceFootNote: Footnote
  @Input() isSmallScreen: boolean
}
